module.exports = __webpack_public_path__ + "img/pleasing.e9de5be1.png";